// Store module for managing breadcrumb navigation history
export default {
  namespaced: true,

  state: {
    history: []
  },

  getters: {
    breadcrumbHistory: state => state.history,
    lastFivePages: (state, getters, rootState) => {
      const maxItems = rootState.userSettings.breadcrumb.maxItems;
      return state.history.slice(-maxItems);
    }
  },

  mutations: {
    ADD_PAGE_TO_HISTORY(state, page) {
      // Helper function to compare query objects
      const areQueriesEqual = (query1, query2) => {
        if (!query1 && !query2) {
          return true;
        }
        if (!query1 || !query2) {
          return false;
        }

        const keys1 = Object.keys(query1);
        const keys2 = Object.keys(query2);

        if (keys1.length !== keys2.length) {
          return false;
        }

        return keys1.every(key => query1[key] === query2[key]);
      };

      // Check if the exact same page (path + query) is the last entry
      const lastEntry = state.history[state.history.length - 1];
      if (
        lastEntry &&
        lastEntry.path === page.path &&
        areQueriesEqual(lastEntry.query, page.query)
      ) {
        // Same page with same query parameters, don't add duplicate
        return;
      }

      // Check if page with same path exists in history
      const existingIndex = state.history.findIndex(
        item => item.path === page.path
      );

      if (existingIndex !== -1) {
        // If it's the last entry and only query changed, update it
        if (existingIndex === state.history.length - 1) {
          state.history[existingIndex] = {
            ...page,
            timestamp: Date.now()
          };
          return;
        } else {
          // Remove existing entry to avoid duplicates
          state.history.splice(existingIndex, 1);
        }
      }

      // Add page to history
      state.history.push({
        ...page,
        timestamp: Date.now()
      });

      // Keep only the configured max number of pages
      // Note: We check against a higher limit to allow for dynamic changes
      if (state.history.length > 10) {
        state.history.shift();
      }
    },

    CLEAR_HISTORY(state) {
      state.history = [];
    }
  },

  actions: {
    addPageToHistory({ commit }, page) {
      commit("ADD_PAGE_TO_HISTORY", page);
    },

    clearHistory({ commit }) {
      commit("CLEAR_HISTORY");
    }
  }
};
